import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import Hero from './components/Hero';
import CompetitionIntro from './components/CompetitionIntro';
import RankingPreview from './components/RankingPreview';
import LatestArticles from './components/LatestArticles';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

export default function Home() {
  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '一起草每日大赛',
      url: 'https://williamallen.cn',
      description: '一起草每日大赛是专为草类竞技爱好者打造的每日在线赛事平台',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://williamallen.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '一起草每日大赛 - 首页',
      description: '一起草每日大赛是专为草类竞技爱好者打造的每日在线赛事平台，每天开启全新挑战，公平竞技、实时排名、丰厚奖励等你来拿。',
      url: 'https://williamallen.cn',
      isPartOf: {
        '@type': 'WebSite',
        name: '一起草每日大赛',
        url: 'https://williamallen.cn',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '如何报名参加一起草每日大赛？',
          acceptedAnswer: { '@type': 'Answer', text: '您可以通过我们的官方网站或官方小程序进行报名。进入"赛事报名"页面，选择您要参加的比赛日期和项目，填写个人信息并完成支付即可。' },
        },
        {
          '@type': 'Question',
          name: '参加比赛需要什么条件？',
          acceptedAnswer: { '@type': 'Answer', text: '参加一起草每日大赛的基本条件包括：年满16周岁、身体健康、无严重心血管疾病等不适合剧烈运动的健康状况。' },
        },
        {
          '@type': 'Question',
          name: '比赛奖励如何发放？',
          acceptedAnswer: { '@type': 'Answer', text: '奖金将在比赛结束后3个工作日内通过银行转账发放至您绑定的账户。实物奖品将在7个工作日内通过快递寄出。' },
        },
        {
          '@type': 'Question',
          name: '如果当天无法参加已报名的比赛，可以退款吗？',
          acceptedAnswer: { '@type': 'Answer', text: '在比赛开始前48小时以上取消报名，可全额退款。24-48小时内取消，退还50%报名费。' },
        },
        {
          '@type': 'Question',
          name: '可以以团队形式参赛吗？',
          acceptedAnswer: { '@type': 'Answer', text: '可以的！我们设有个人赛和团队赛两种模式。团队赛支持2-4人组队参加。' },
        },
        {
          '@type': 'Question',
          name: '新人应该如何开始？',
          acceptedAnswer: { '@type': 'Answer', text: '我们强烈建议新人先从"新人入门"分类的赛事开始参与。可以浏览网站上的新人入门文章和教程视频。' },
        },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title="一起草每日大赛 - 每天挑战，赢取丰厚奖励 | 草类竞技在线赛事平台"
        description="一起草每日大赛是专为草类竞技爱好者打造的每日在线赛事平台，每天开启全新挑战，公平竞技、实时排名、丰厚奖励等你来拿。立即参与一起草每日大赛，与全国玩家同台竞技，展示你的实力！"
        keywords="一起草每日大赛,一起草大赛报名,每日竞技挑战赛,一起草排行榜,草类竞技平台,每日在线大赛,一起草奖励活动"
        canonicalUrl="https://williamallen.cn"
        schemaData={schemaData}
      />
      <Navbar />
      <main>
        <Hero />
        <CompetitionIntro />
        <RankingPreview />
        <LatestArticles />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}